import { useState, useEffect } from "react";
import { type FormData } from "./formSchema";

interface UseCsvUploadFormReturn {
  isButtonDisabled: boolean;
  handleFileChangeWrapper: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmitCsv: (data: FormData) => void;
  handleCsvUploadButtonClick: () => void;
}

interface UseCsvUploadFormProps {
  fileToCsvUpload: File | null;
  csvUploadLoading: boolean;
  nameValue: string;
  handleFileChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  uploadCsv: (name: string, tags?: string[], mapPlotRequestId?: number) => void;
  handleSubmit: (callback: (data: FormData) => void) => () => Promise<void>;
}

/**
 * CSVアップロードフォームの状態管理を行うカスタムフック
 */
export const useCsvUploadForm = ({
  fileToCsvUpload,
  csvUploadLoading,
  nameValue,
  handleFileChange,
  uploadCsv,
  handleSubmit,
}: UseCsvUploadFormProps): UseCsvUploadFormReturn => {
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

  useEffect(() => {
    setIsButtonDisabled(
      !fileToCsvUpload || csvUploadLoading || !nameValue.trim()
    );
  }, [fileToCsvUpload, csvUploadLoading, nameValue]);

  /**
   * ファイル選択イベントのラッパー関数です。
   * 非同期のhandleFileChangeを呼び出します。
   * @param event - ファイル入力要素の変更イベント
   */
  const handleFileChangeWrapper = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    void handleFileChange(event);
  };

  /**
   * CSVアップロードのフォーム送信時の処理です。
   * @param data - フォームデータ（name, tags, mapPlotRequestId プロパティを含む）
   */
  const onSubmitCsv = (data: FormData): void => {
    uploadCsv(data.name, data.tags, data.mapPlotRequestId);
  };

  /**
   * CSVアップロードボタンクリック時の処理です。
   * フォームバリデーションを実行してからCSVをアップロードします。
   */
  const handleCsvUploadButtonClick = (): void => {
    void handleSubmit(onSubmitCsv)();
  };

  return {
    isButtonDisabled,
    handleFileChangeWrapper,
    onSubmitCsv,
    handleCsvUploadButtonClick,
  };
};
